
import {filter} from 'rxjs/operators';
import { Injectable} from '@angular/core';
import { Router, NavigationEnd, Route } from '@angular/router';
import { Location } from '@angular/common';

@Injectable()
export class RouterTrackerService {

    private history: Array<string> = [];
    
    constructor(
        private router: Router,
        private location: Location
    ) {}

    /**
     * Inicia o tracking da navegação do usuário.
     */
    public startTracking() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd))
            .subscribe(({urlAfterRedirects}: NavigationEnd) => {
                this.history = [...this.history, urlAfterRedirects];
            });
    }

    /**
     * Retorna o histórico da navegação do usuário.
     */
    public getHistory(): Array<string> {
        return this.history;
    }

    /**
     * Retorna a última rota baseada em uma posição.
     * @param lastRoute número da última rota.
     */
    public getLastRoute(lastRoute: number = 0): string {
        return this.history[this.history.length - (lastRoute - 1)];
    }

    /**
     * Navega para a rota anterior.
     * @param time Quantas rotas voltar
     */
    public back(time: number = 1) {
        const path = this.history[this.history.length - (time + 1)];
        if(path) {
            this.router.navigateByUrl(path);
            this.history = this.history.slice(0, this.history.length - 2);
        } else {
            this.location.back();
        }
    }


}